var React = require('react');

function ArrowRightPart2Inline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.85453.31818,8.7682,7.2318a1.08643,1.08643,0,0,1,0,1.53637L1.85453,15.68182A1.08636,1.08636,0,0,1,.31819,14.14547L5.37731,9.08636,6.46625,8,5.37731,6.91362.31819,1.85454A1.08636,1.08636,0,0,1,1.85453.31818Z","fill":"#e21d6c","fillRule":"evenodd"}));
}

ArrowRightPart2Inline.defaultProps = {"width":"9.08638","height":"16.00001","viewBox":"0 0 9.08638 16.00001"};

module.exports = ArrowRightPart2Inline;

ArrowRightPart2Inline.default = ArrowRightPart2Inline;
